// URL import, not the generated React component. `icons/colored/GoogleWorkspace.js`
// inlines a raster image as base64 inside the SVG — 24.5 KB gzipped of JS for a
// 58x58 logo. Nudges render in the ATS shell, so it sat in the entry chunk for
// every visitor. As a URL the browser fetches it separately and caches it.
import googleLogoUrl from '@/assets/svg/colored/google-workspace.svg';

/**
 * Draws the Google Workspace logo from its URL.
 *
 * A nudge's `cta.icon` is a component everywhere else, so wrapping the URL keeps
 * that contract and leaves every consumer untouched. Incoming props are ignored
 * on purpose: Chakra renders this via `<Icon as={...}>`, which supplies SVG
 * attributes that mean nothing to an `<img>`. Sized at 16px to match the 1em the
 * icon rendered at before.
 *
 * `alt` is empty because the adjacent CTA label already names the action.
 */
export const GoogleWorkspaceLogo = () => (
  <img src={googleLogoUrl} alt="" width="16" height="16" />
);
